import productPanels from '@/assets/products/category-panels.jpg';
import productPergolas from '@/assets/products/category-pergolas.jpg';
import productGlass from '@/assets/products/category-glass.jpg';
import productFurniture from '@/assets/products/category-furniture.jpg';
import productStone from '@/assets/products/category-stone.jpg';

/**
 * Serbian content for Wall Lux Trade website
 */

export const content = {
  company: {
    name: 'Wall Lux Trade',
    fullName: 'Wall Lux Trade DOO',
    tagline: 'Luxury Interior Solutions',
    description: 'Uvoz i prodaja građevinskog materijala',
    address: 'Nemanjina 68, Užice',
    /** Koordinate za mapu (iste lokacije kao adresa). Ažurirati ako se adresa promeni. */
    mapLat: 43.8592518,
    mapLng: 19.8491067,
    phone: '+381 631732274',
    email: 'wallluxtrade@gmail.com',
    workingHours: 'Pon - Pet: 08:00 - 17:00, Sub: 09:00 - 14:00',
  },

  navigation: {
    home: 'Početna',
    about: 'O nama',
    products: 'Proizvodi',
    projects: 'Projekti',
    references: 'Reference',
    collaborate: 'Saradjujte',
    shop: 'Prodavnica',
  },

  hero: {
    caption: 'Premium dekorativni paneli za enterijere',
    title: 'Transformišite Vaš Prostor',
    subtitle: 'Praktičan, cenovno pristupačan i estetski privlačan izbor za uređenje enterijera svakog doma po vašem ukusu.',
    cta: 'Kontaktirajte Nas',
    ctaSecondary: 'Pogledajte Ponudu',
  },

  benefits: {
    caption: 'Zašto Wall Lux Trade',
    title: 'Vaš Partner Za Kvalitet',
    items: [
      {
        title: 'Brza Isporuka',
        description: 'Efikasna usluga i brza isporuka na teritoriji cele Srbije.',
        icon: 'truck',
      },
      {
        title: 'Premium Kvalitet',
        description: 'Samo najbolji materijali od proverenih evropskih proizvođača.',
        icon: 'award',
      },
      {
        title: 'Pristupačne Cene',
        description: 'Konkurentne cene bez kompromisa u kvalitetu.',
        icon: 'tag',
      },
      {
        title: 'Stručna Podrška',
        description: 'Tim stručnjaka spreman da vam pomogne u svakom koraku.',
        icon: 'headphones',
      },
    ],
  },

  products: {
    shopHint:
      'Odabrane artikle možete naručiti odmah, uz plaćanje pouzećem i dostavu na teritoriji cele Srbije.',
    caption: 'Naša Ponuda',
    title: 'Enterijer, bašta i terasa',
    subtitle:
      'Zidni i dekorativni paneli, rešenja za baštu i terasu, staklo, nameštaj po meri i prirodni kamen, sve na jednom mestu.',
    categories: [
      {
        id: 'panels',
        name: 'Dekorativni paneli',
        description:
          'Zidni paneli i imitacije drveta, kamena i granita za enterijer.',
        image: productPanels,
      },
      {
        id: 'pergolas',
        name: 'Bioklimatske i platnene pergole',
        description: 'Pergole za terasu i baštu - bioklimatske i platnene varijante.',
        image: productPergolas,
      },
      {
        id: 'glass',
        name: 'Stakleni krovovi i giljotina',
        description: 'Stakleni krovovi i giljotina sistem stakljenja za moderan prostor.',
        image: productGlass,
      },
      {
        id: 'furniture',
        name: 'Nameštaj po meri',
        description: 'Kuhinje, ormari i nameštaj po meri prema vašim merama.',
        image: productFurniture,
      },
      {
        id: 'natural-stone',
        name: 'Prirodni kamen i mermer',
        description: 'Prodaja i ugradnja prirodnog kamena, granita i mermera.',
        image: productStone,
      },
    ],
    cta: 'Pogledajte Sve Proizvode',
  },

  about: {
    caption: 'O Nama',
    title: 'Wall Lux Trade DOO',
    subtitle: 'Uvoz i prodaja građevinskog materijala, Užice',
    description: `Wall Lux Trade je dobavljač dekorativnih panela za enterijer u Srbiji. 
    Specijalizovani smo za premium panele koji imitiraju drvo, granit i kamen, 
    donoseći luksuzni izgled po pristupačnim cenama.

    Radimo i kompletna rešenja za baštu i terasu kao što su bioklimatske pergole, platnene pergole, 
    staklene krovove i giljotina sistem stakljenja. Bavimo se i nameštajem po meri 
    (kuhinje i ormari), kao i prodajom i ugradnjom prirodnog kamena, granita i mermera.
    
    Sa sedištem u Užicu, opslužujemo klijente širom Srbije, od privatnih korisnika 
    do građevinskih preduzeća i preduzetnika. Naša misija je da transformišemo 
    svaki prostor u oazu stila i elegancije.`,
    values: [
      { title: 'Kvalitet', description: 'Samo premium materijali od proverenih dobavljača.' },
      { title: 'Pouzdanost', description: 'Dostava na vreme, svaki put.' },
      { title: 'Podrška', description: 'Stručni saveti od našeg tima.' },
    ],
  },

  projects: {
    caption: 'Projekti',
    title: 'Realizacije',
    subtitle:
      'Ovde se nalaze izabrane reference i enterijere na kojima su korišćeni naši materijali.',
    comingSoonTitle: 'Fotografije projekata stižu uskoro',
    comingSoonBody:
      'Radimo na prikupljanju i obradi vizuala sa terena kako bismo vam pružili reprezentativan prikaz kvaliteta i završne obrade. Galerija će biti ažurirana automatski kada budu dostupni novi projekti.',
    comingSoonHint:
      'Do tada možete nas kontaktirati za konsultacije, uzorke materijala ili ponudu prilagođenu vašem prostoru.',
    cta: 'Kontaktirajte nas',
  },

  references: {
    caption: 'Reference',
    title: 'Utisci klijenata',
    subtitle: 'Iskustva klijenata koji su uređivali enterijer sa našim materijalima.',
    items: [
      {
        name: 'Miloš Trzin',
        company: 'Privatni korisnik, Beograd',
        text: 'Uzeli smo panele u imitaciji drveta koji su se savršeno uklopili u naš enterijer. Bukvalno izgledaju kao pravo drvo, a ne kao obična obloga. Prijatelji su odmah pitali gde smo to nabavili i sa zadovoljstvom smo preporučili Wall Lux Trade.',
      },
      {
        name: 'Daliborka Pejatović',
        company: 'Privatni korisnik, Zlatibor',
        text: 'Za apartman na planini tražili smo nešto otporno na vlagu i lako za održavanje. Kameni efekat koji smo izabrali uz savet tima bio je tačno ono što smo želeli, a prostor i dalje izgleda sveže i skupo, iako smo držali budžet pod kontrolom.',
      },
      {
        name: 'Gojko Planić',
        company: 'Privatni korisnik, Beograd',
        text: 'Radili smo dnevni boravak i hodnik. Isporuka je stigla u roku, a boja i struktura panela na licu mesta potpuno su odgovarale uzorku koji smo videli kod njih. Kvalitet se oseti čim uđete u prostor, zato bih ih preporučio svakome ko ne želi kompromise.',
      },
    ],
  },

  contact: {
    caption: 'Kontakt',
    title: 'Javite Nam Se',
    subtitle: 'Imate pitanje? Pošaljite nam poruku ili nas pozovite direktno.',
    form: {
      name: 'Ime i prezime',
      phone: 'Telefon',
      email: 'Email adresa',
      message: 'Vaša poruka',
      submit: 'Pošaljite Poruku',
      sending: 'Slanje...',
      success: 'Hvala! Vaša poruka je uspešno poslata. Javićemo vam se uskoro.',
      error: 'Došlo je do greške. Molimo pokušajte ponovo ili nas pozovite direktno.',
    },
    info: {
      addressTitle: 'Adresa',
      phoneTitle: 'Telefon',
      emailTitle: 'Email',
      workingHoursTitle: 'Radno vreme',
    },
    cta: {
      whatsapp: 'WhatsApp',
      viber: 'Viber',
      call: 'Pozovite Nas',
    },
  },

  cta: {
    title: 'Spremni Da Transformišete Vaš Prostor?',
    subtitle: 'Kontaktirajte nas danas i saznajte više o našoj ponudi.',
    button: 'Kontaktirajte Nas',
  },

  footer: {
    description: 'Wall Lux Trade DOO — Uvoz i prodaja građevinskog materijala. Vaš partner za kvalitetne enterijer rešenja.',
    quickLinks: 'Brzi Linkovi',
    contact: 'Kontakt',
    followUs: 'Pratite Nas',
    copyright: '© 2024 Wall Lux Trade DOO. Sva prava zadržana.',
  },

  validation: {
    required: 'Ovo polje je obavezno',
    invalidEmail: 'Unesite validnu email adresu',
    invalidPhone: 'Unesite validan broj telefona',
    minLength: 'Minimalno {min} karaktera',
  },
};

export default content;
